module.exports={
  "237": {"url": "http://princewilliam-ng.libraryreserve.com/"},
  "100501": {"url": "http://qaintegration-ng.libraryreserve.com/"}
}